import { apiClient } from '@/shared/lib/axios';

export interface TenantDto {
  id: number;
  name: string;
  site_type: string;
  status: number;
  is_master: boolean;
  parent_id: number | null;
}

export interface TenantsListResponse {
  success: boolean;
  data: TenantDto[];
}

/**
 * `rootsOnly` giới hạn về tenant gốc (`parent_id IS NULL`) — nguồn của dropdown サイト区分 theo BD.
 *
 * Lọc ở server chứ không ở client: cùng một endpoint còn phục vụ các bộ lọc khác cần cả tenant con,
 * nên cờ này phải là lựa chọn của người gọi. Mặc định giữ nguyên hành vi cũ.
 */
export const getTenants = async (site: string, rootsOnly = false): Promise<TenantDto[]> => {
  const res = await apiClient.get<TenantsListResponse>(`/admin/${site}/tenants`, {
    params: rootsOnly ? { roots_only: 1 } : undefined,
  });
  return res.data.data;
};
